/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Benefits_HeadingInputs */

const et_benefits_heading = /** @type {(inputs: Benefits_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`, kas see on üldse väärt?`)
};

const en_benefits_heading = /** @type {(inputs: Benefits_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`, is it actually worth it?`)
};

/**
* | output |
* | --- |
* | ", is it actually worth it?" |
*
* @param {Benefits_HeadingInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const benefits_heading = /** @type {((inputs?: Benefits_HeadingInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Benefits_HeadingInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_benefits_heading(inputs)
	return en_benefits_heading(inputs)
});